import styled from "styled-components";

import { Flex } from "@olist/design-system";

export const CommentContainer = styled(Flex)<{ id: string }>`
  align-items: flex-start;
  column-gap: ${({ theme }) => theme.olist.spacing.inline["1xsmall"]};
  display: flex;
  justify-content: flex-start;
`;

export const CommentWrapper = styled(Flex)`
  flex-direction: column;
  max-width: 80%;
  overflow-wrap: break-word;
  row-gap: ${({ theme }) => theme.olist.spacing.stack["1xsmall"]};
  white-space: normal;
  word-break: break-word;
`;

export const Attachment = styled(Flex)<{ id: string }>`
  border: 1px solid ${({ theme }) => theme.olist.color.neutral.soft};
  border-radius: 8px;
  column-gap: ${({ theme }) => theme.olist.spacing.inline.small};
  padding: 8px;
  img {
    max-width: 100%;
  }
`;
